/**
 * On-Site Portal — route configuration.
 * Mobile-first PWA for field engineers.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { HealthPage } from './pages/HealthPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectPage } from './pages/ProjectPage';
import { BriefPage } from './pages/BriefPage';
import { DailyReportPage } from './pages/DailyReportPage';
import { NetworkPage } from './pages/NetworkPage';
import { InventoryPage } from './pages/InventoryPage';
import { LifecyclePage } from './pages/LifecyclePage';
import { IntelPage } from './pages/IntelPage';
import { CrmEntryPage } from './pages/CrmEntryPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/health" element={<HealthPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="crm/account/:zohoAccountId" element={<CrmEntryPage />} />
          <Route path="project" element={<ProjectPage />} />
          <Route path="brief" element={<BriefPage />} />
          <Route path="daily-report" element={<DailyReportPage />} />
          <Route path="network" element={<NetworkPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="lifecycle" element={<LifecyclePage />} />
          <Route path="intel" element={<IntelPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
